/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInviteOutcome } from "../models/AcceptInviteOutcome";
import type { AccessCode } from "../models/AccessCode";
import type { AccessCodeIds } from "../models/AccessCodeIds";
import type { AccessCodesBulkCreate } from "../models/AccessCodesBulkCreate";
import type { AccessCodesBulkUpdate } from "../models/AccessCodesBulkUpdate";
import type { AccessCodeSeries } from "../models/AccessCodeSeries";
import type { AccessCodeSeriesData } from "../models/AccessCodeSeriesData";
import type { AccessCodeSeriesIds } from "../models/AccessCodeSeriesIds";
import type { AccessCodesSearch } from "../models/AccessCodesSearch";
import type { Agreement } from "../models/Agreement";
import type { AgreementAccess } from "../models/AgreementAccess";
import type { AgreementIds } from "../models/AgreementIds";
import type { AgreementOfferReply } from "../models/AgreementOfferReply";
import type { AgreementSettings } from "../models/AgreementSettings";
import type { AgreementSettingsData } from "../models/AgreementSettingsData";
import type { AgreementsWithEndDate } from "../models/AgreementsWithEndDate";
import type { AgreementUpdate } from "../models/AgreementUpdate";
import type { AgreementUpdateResult } from "../models/AgreementUpdateResult";
import type { ApplicantIds } from "../models/ApplicantIds";
import type { AppSites } from "../models/AppSites";
import type { Area } from "../models/Area";
import type { AreaData } from "../models/AreaData";
import type { AuthToken } from "../models/AuthToken";
import type { Base64 } from "../models/Base64";
import type { BillectaCreditor } from "../models/BillectaCreditor";
import type { BillectaCreditorData } from "../models/BillectaCreditorData";
import type { BillectaCreditorRef } from "../models/BillectaCreditorRef";
import type { BillectaSyncTarget } from "../models/BillectaSyncTarget";
import type { CalculateSiteStats } from "../models/CalculateSiteStats";
import type { CalculationOutcome } from "../models/CalculationOutcome";
import type { ClearSiteStats } from "../models/ClearSiteStats";
import type { CommissionData } from "../models/CommissionData";
import type { ConnectAccessCodeSeriesOutcome } from "../models/ConnectAccessCodeSeriesOutcome";
import type { CounterState } from "../models/CounterState";
import type { CreateAccessCodeSeries } from "../models/CreateAccessCodeSeries";
import type { CreateDebtorUser } from "../models/CreateDebtorUser";
import type { CreatedSpotGroup } from "../models/CreatedSpotGroup";
import type { CreatePermitGrant } from "../models/CreatePermitGrant";
import type { CreatePermitOutcome } from "../models/CreatePermitOutcome";
import type { CreateSpotGroup } from "../models/CreateSpotGroup";
import type { CreateSpotShare } from "../models/CreateSpotShare";
import type { CsvImportOutcome } from "../models/CsvImportOutcome";
import type { Date } from "../models/Date";
import type { Days } from "../models/Days";
import type { Debtor } from "../models/Debtor";
import type { DebtorBatchDeleteResult } from "../models/DebtorBatchDeleteResult";
import type { DebtorData } from "../models/DebtorData";
import type { DebtorDeleteResult } from "../models/DebtorDeleteResult";
import type { DebtorDeliveryMethod } from "../models/DebtorDeliveryMethod";
import type { DebtorId2 } from "../models/DebtorId2";
import type { DebtorIds } from "../models/DebtorIds";
import type { DebtorInvoiceSub } from "../models/DebtorInvoiceSub";
import type { DebtorPaymentMethod } from "../models/DebtorPaymentMethod";
import type { DebtorUser } from "../models/DebtorUser";
import type { DebtorWithPaymentCards } from "../models/DebtorWithPaymentCards";
import type { Device } from "../models/Device";
import type { DeviceData } from "../models/DeviceData";
import type { DeviceIds } from "../models/DeviceIds";
import type { DpLiteAccess } from "../models/DpLiteAccess";
import type { DpLiteCreateUserWithAccess } from "../models/DpLiteCreateUserWithAccess";
import type { DpLiteSearch } from "../models/DpLiteSearch";
import type { DpLiteSetAccess } from "../models/DpLiteSetAccess";
import type { DpLiteSetPassword } from "../models/DpLiteSetPassword";
import type { DpLiteUserWithAccess } from "../models/DpLiteUserWithAccess";
import type { Entrance } from "../models/Entrance";
import type { EntranceData } from "../models/EntranceData";
import type { EntranceIds } from "../models/EntranceIds";
import type { FinalizePaymentCardSetup } from "../models/FinalizePaymentCardSetup";
import type { FinalizePaymentCardSetupWithAuthToken } from "../models/FinalizePaymentCardSetupWithAuthToken";
import type { GrantIds } from "../models/GrantIds";
import type { Id } from "../models/Id";
import type { ImportP46Site } from "../models/ImportP46Site";
import type { Indexes } from "../models/Indexes";
import type { Invite } from "../models/Invite";
import type { LenderInfo } from "../models/LenderInfo";
import type { LenderInfoData } from "../models/LenderInfoData";
import type { LoginStatus } from "../models/LoginStatus";
import type { LogMessage } from "../models/LogMessage";
import type { MasqueradeResult } from "../models/MasqueradeResult";
import type { MasqueradeTarget } from "../models/MasqueradeTarget";
import type { Months } from "../models/Months";
import type { MyPagesSite } from "../models/MyPagesSite";
import type { MyPagesStart } from "../models/MyPagesStart";
import type { NewEntrance } from "../models/NewEntrance";
import type { NewQueueApplicant } from "../models/NewQueueApplicant";
import type { NumRemoved } from "../models/NumRemoved";
import type { Paginated_for_AccessCode } from "../models/Paginated_for_AccessCode";
import type { Paginated_for_AccessCodeSeries } from "../models/Paginated_for_AccessCodeSeries";
import type { Paginated_for_ClientRow } from "../models/Paginated_for_ClientRow";
import type { Paginated_for_Entrance } from "../models/Paginated_for_Entrance";
import type { Paginated_for_MyPagesSpot } from "../models/Paginated_for_MyPagesSpot";
import type { Paginated_for_Payment } from "../models/Paginated_for_Payment";
import type { Paginated_for_PaymentWithDebtor } from "../models/Paginated_for_PaymentWithDebtor";
import type { Paginated_for_PermitGrantInfo } from "../models/Paginated_for_PermitGrantInfo";
import type { Paginated_for_PermitSession } from "../models/Paginated_for_PermitSession";
import type { Paginated_for_ProductRow } from "../models/Paginated_for_ProductRow";
import type { Paginated_for_PublicSiteRow } from "../models/Paginated_for_PublicSiteRow";
import type { Paginated_for_SentEmail } from "../models/Paginated_for_SentEmail";
import type { Paginated_for_SiteRow } from "../models/Paginated_for_SiteRow";
import type { Paginated_for_SpotShare } from "../models/Paginated_for_SpotShare";
import type { PaymentCard } from "../models/PaymentCard";
import type { PaymentCardSetup } from "../models/PaymentCardSetup";
import type { PayPermitOutcome } from "../models/PayPermitOutcome";
import type { PermitCreate } from "../models/PermitCreate";
import type { PermitGrant } from "../models/PermitGrant";
import type { PermitPayPreview } from "../models/PermitPayPreview";
import type { PermitSession } from "../models/PermitSession";
import type { PermitSessionData } from "../models/PermitSessionData";
import type { PostPaymentReceipt } from "../models/PostPaymentReceipt";
import type { Product } from "../models/Product";
import type { ProductCommission } from "../models/ProductCommission";
import type { ProductData } from "../models/ProductData";
import type { ProductSearch } from "../models/ProductSearch";
import type { PublicSearchSites } from "../models/PublicSearchSites";
import type { PublicSearchSpotClasses } from "../models/PublicSearchSpotClasses";
import type { Queue } from "../models/Queue";
import type { QueueApplicant } from "../models/QueueApplicant";
import type { QueueApplicantData } from "../models/QueueApplicantData";
import type { QueueApplicantRef } from "../models/QueueApplicantRef";
import type { QueueData } from "../models/QueueData";
import type { QueueStep } from "../models/QueueStep";
import type { QueueStepData } from "../models/QueueStepData";
import type { QueueStepTag } from "../models/QueueStepTag";
import type { QueueTagsAvailability } from "../models/QueueTagsAvailability";
import type { RegisterFcmToken } from "../models/RegisterFcmToken";
import type { RentalInfo } from "../models/RentalInfo";
import type { RentalInfoData } from "../models/RentalInfoData";
import type { SearchAccessCodeSeries } from "../models/SearchAccessCodeSeries";
import type { SearchAgreements } from "../models/SearchAgreements";
import type { SearchClients } from "../models/SearchClients";
import type { SearchDebtors } from "../models/SearchDebtors";
import type { SearchEmails } from "../models/SearchEmails";
import type { SearchEntrances } from "../models/SearchEntrances";
import type { SearchGrants } from "../models/SearchGrants";
import type { SearchP46Debtors } from "../models/SearchP46Debtors";
import type { SearchP46Sites } from "../models/SearchP46Sites";
import type { SearchPayments } from "../models/SearchPayments";
import type { SearchPermitSessions } from "../models/SearchPermitSessions";
import type { SearchQueueTags } from "../models/SearchQueueTags";
import type { SearchResponse_for_Agreement } from "../models/SearchResponse_for_Agreement";
import type { SearchResponse_for_IndexedDebtor } from "../models/SearchResponse_for_IndexedDebtor";
import type { SearchResponse_for_MyPagesSpot } from "../models/SearchResponse_for_MyPagesSpot";
import type { SearchResponse_for_P46Debtor } from "../models/SearchResponse_for_P46Debtor";
import type { SearchResponse_for_P46Site } from "../models/SearchResponse_for_P46Site";
import type { SearchResponse_for_Spot } from "../models/SearchResponse_for_Spot";
import type { SearchSites } from "../models/SearchSites";
import type { SearchSpotClasses } from "../models/SearchSpotClasses";
import type { SearchSpots } from "../models/SearchSpots";
import type { SearchSpots2 } from "../models/SearchSpots2";
import type { SearchSpots3 } from "../models/SearchSpots3";
import type { SearchSpotShares } from "../models/SearchSpotShares";
import type { SearchSystemClients } from "../models/SearchSystemClients";
import type { SearchSystemPayments } from "../models/SearchSystemPayments";
import type { SearchSystemSites } from "../models/SearchSystemSites";
import type { SentEmail } from "../models/SentEmail";
import type { Site } from "../models/Site";
import type { SiteConnections } from "../models/SiteConnections";
import type { SiteData } from "../models/SiteData";
import type { SiteIds } from "../models/SiteIds";
import type { SiteStats } from "../models/SiteStats";
import type { Spot } from "../models/Spot";
import type { SpotBatchCreate } from "../models/SpotBatchCreate";
import type { SpotBatchUpdate } from "../models/SpotBatchUpdate";
import type { SpotClass } from "../models/SpotClass";
import type { SpotClassSpotSearch } from "../models/SpotClassSpotSearch";
import type { SpotData } from "../models/SpotData";
import type { SpotShare } from "../models/SpotShare";
import type { SpotsSetArea } from "../models/SpotsSetArea";
import type { StartLogin } from "../models/StartLogin";
import type { StoreTestReply } from "../models/StoreTestReply";
import type { SupportInfo } from "../models/SupportInfo";
import type { SyncProductsOutome } from "../models/SyncProductsOutome";
import type { SystemClient } from "../models/SystemClient";
import type { SystemSite } from "../models/SystemSite";
import type { Tag } from "../models/Tag";
import type { TagData } from "../models/TagData";
import type { TagIds } from "../models/TagIds";
import type { TagWithAssociations } from "../models/TagWithAssociations";
import type { Terms } from "../models/Terms";
import type { UpdateLicensePlate } from "../models/UpdateLicensePlate";
import type { UpdateLicensePlateOutcome } from "../models/UpdateLicensePlateOutcome";
import type { UpdateSpotShare } from "../models/UpdateSpotShare";
import type { UserIds } from "../models/UserIds";
import type { ValidateAccessCode } from "../models/ValidateAccessCode";
import type { Ym } from "../models/Ym";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class DefaultService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Sys Search Rebuild
   * Rebuilds the given search indexes
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public sysSearchRebuild(
    requestBody: Indexes,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/admin/search/rebuild",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * adminSyncFinnProducts
   * syncs products and billecta products with Finn
   * @returns SyncProductsOutome
   * @throws ApiError
   */
  public adminSyncFinnProducts(): CancelablePromise<SyncProductsOutome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/admin/sync/finn/products",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Sys warn
   * Forces a warning message to be logged.
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public sysWarn(
    requestBody: LogMessage,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/admin/log/warning",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Sys error
   * Forces an error message to be logged.
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public sysError(
    requestBody: LogMessage,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/admin/log/error",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * System masquerade
   * Masquerade as a specific user
   * @param requestBody
   * @returns MasqueradeResult
   * @throws ApiError
   */
  public masquerade(
    requestBody: MasqueradeTarget,
  ): CancelablePromise<MasqueradeResult> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/masquerade",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * System sites search
   * Search system sites
   * @param requestBody
   * @returns SystemSite
   * @throws ApiError
   */
  public searchSystemSites(
    requestBody: SearchSystemSites,
  ): CancelablePromise<Array<SystemSite>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/sites/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * System client search
   * Search system clients
   * @param requestBody
   * @returns SystemClient
   * @throws ApiError
   */
  public searchSystemClients(
    requestBody: SearchSystemClients,
  ): CancelablePromise<Array<SystemClient>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/clients/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * System sync Billecta
   * System sync a Billecta target
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public sysSyncBillecta(
    requestBody: BillectaSyncTarget,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/sync/billecta",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Recalculate tag tenancy table
   * Recalculate tag tenancies and save to the table
   * @param requestBody
   * @returns CalculationOutcome
   * @throws ApiError
   */
  public calculateTagTenancies(
    requestBody: CalculateSiteStats,
  ): CancelablePromise<CalculationOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/reports/tag_tenancies/calculate",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Recalculate classification counts table
   * Recalculate classification counts and save to the table
   * @param requestBody
   * @returns CalculationOutcome
   * @throws ApiError
   */
  public calculateClassificationCounts(
    requestBody: CalculateSiteStats,
  ): CancelablePromise<CalculationOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/reports/classification_counts",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Clear entries in the classification counts table
   * Clear entries in the classification counts table
   * @param requestBody
   * @returns NumRemoved
   * @throws ApiError
   */
  public clearClassificationCounts(
    requestBody: ClearSiteStats,
  ): CancelablePromise<NumRemoved> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/system/reports/classification_counts",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Get a sent email
   * Gets an email sent by the system
   * @param id
   * @returns SentEmail
   * @throws ApiError
   */
  public getSentEmail(
    id: string,
  ): CancelablePromise<SentEmail> {
    return this.httpRequest.request({
      method: "GET",
      url: "/system/emails/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Search sent emails
   * Searches emails sent by the system
   * @param requestBody
   * @returns Paginated_for_SentEmail
   * @throws ApiError
   */
  public searchSentEmails(
    requestBody: SearchEmails,
  ): CancelablePromise<Paginated_for_SentEmail> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/emails",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * System Search Payments
   * System Search payments
   * @param requestBody
   * @returns Paginated_for_PaymentWithDebtor
   * @throws ApiError
   */
  public systemSearchPayments(
    requestBody: SearchSystemPayments,
  ): CancelablePromise<Paginated_for_PaymentWithDebtor> {
    return this.httpRequest.request({
      method: "POST",
      url: "/system/payments",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * @param code
   * @returns StoreTestReply
   * @throws ApiError
   */
  public loginStoreTest(
    code: string,
  ): CancelablePromise<StoreTestReply> {
    return this.httpRequest.request({
      method: "GET",
      url: "/login/store-test",
      query: {
        "code": code,
      },
    });
  }
  /**
   * @param requestBody
   * @returns LoginStatus
   * @throws ApiError
   */
  public startLogin(
    requestBody: StartLogin,
  ): CancelablePromise<LoginStatus> {
    return this.httpRequest.request({
      method: "POST",
      url: "/login",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @param id
   * @returns LoginStatus
   * @throws ApiError
   */
  public getLoginStatus(
    id: string,
  ): CancelablePromise<LoginStatus> {
    return this.httpRequest.request({
      method: "GET",
      url: "/login/status/{id}",
      path: {
        "id": id,
      },
    });
  }
  /**
   * @param id
   * @returns any no content
   * @throws ApiError
   */
  public cancelLogin(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/login/cancel/{id}",
      path: {
        "id": id,
      },
    });
  }
  /**
   * Get app data
   * Get data generally used by the app
   * @returns AppSites
   * @throws ApiError
   */
  public appSites(): CancelablePromise<AppSites> {
    return this.httpRequest.request({
      method: "GET",
      url: "/app/sites",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Register token for push notifications
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public registerFcmToken(
    requestBody: RegisterFcmToken,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/app/register-fcm",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * MyPages Start
   * @returns MyPagesStart
   * @throws ApiError
   */
  public startMyPages(): CancelablePromise<MyPagesStart> {
    return this.httpRequest.request({
      method: "GET",
      url: "/mypages/start",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Accept user invite
   * @param requestBody
   * @returns AcceptInviteOutcome
   * @throws ApiError
   */
  public acceptUserInvite(
    requestBody: Invite,
  ): CancelablePromise<AcceptInviteOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/mypages/accept-invite",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Get all agreements that belong to the debtors that are connected to the user
   * @returns AgreementAccess
   * @throws ApiError
   */
  public getMyAgreements(): CancelablePromise<Array<AgreementAccess>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/mypages/agreements",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Get all sites that the user's debtors have access to.
   * @returns MyPagesSite
   * @throws ApiError
   */
  public getMySites(): CancelablePromise<Array<MyPagesSite>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/mypages/sites",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site search
   * Paginated search of sites
   * @param requestBody
   * @returns Paginated_for_SiteRow
   * @throws ApiError
   */
  public siteSearch(
    requestBody: SearchSites,
  ): CancelablePromise<Paginated_for_SiteRow> {
    return this.httpRequest.request({
      method: "POST",
      url: "/sites/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site get all
   * Get all sites
   * @returns Site
   * @throws ApiError
   */
  public siteGetAll(): CancelablePromise<Array<Site>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site create
   * Create a new site
   * @param requestBody
   * @returns Site
   * @throws ApiError
   */
  public siteCreate(
    requestBody: SiteData,
  ): CancelablePromise<Site> {
    return this.httpRequest.request({
      method: "POST",
      url: "/sites",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site get
   * Get a site by id
   * @param id Site id
   * @returns Site
   * @throws ApiError
   */
  public siteGet(
    id: string,
  ): CancelablePromise<Site> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site update
   * Update a site by id
   * @param id Site id
   * @param requestBody
   * @returns Site
   * @throws ApiError
   */
  public sitePut(
    id: string,
    requestBody: SiteData,
  ): CancelablePromise<Site> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site get Terms
   * Get the terms of a site
   * @param id Site id
   * @returns any
   * @throws ApiError
   */
  public getSiteTerms(
    id: string,
  ): CancelablePromise<(Terms | null)> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/terms",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site set Terms
   * Set terms for a site
   * @param id Site id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public setSiteTerms(
    id: string,
    requestBody: string,
  ): CancelablePromise<(Terms | null)> {
    return this.httpRequest.request({
      method: "POST",
      url: "/sites/{id}/terms",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site get SupportInfo
   * Get the support info for a site
   * @param id Site id
   * @returns any
   * @throws ApiError
   */
  public getSiteSupportInfo(
    id: string,
  ): CancelablePromise<(SupportInfo | null)> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/support_info",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site set SupportInfo
   * Set the support info for a site
   * @param id Site id
   * @param requestBody
   * @returns SupportInfo
   * @throws ApiError
   */
  public setSiteSupportInfo(
    id: string,
    requestBody: string,
  ): CancelablePromise<SupportInfo> {
    return this.httpRequest.request({
      method: "POST",
      url: "/sites/{id}/support_info",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tags get for site
   * Get all tags used in a site
   * @param id Site id
   * @returns Tag
   * @throws ApiError
   */
  public siteTagsGet(
    id: string,
  ): CancelablePromise<Array<Tag>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/tags",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Areas get for site
   * Get all areas in a site
   * @param id Site id
   * @returns Area
   * @throws ApiError
   */
  public siteAreasGet(
    id: string,
  ): CancelablePromise<Array<Area>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/areas",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Areas create for site
   * Create an Area in site
   * @param id Site id
   * @param requestBody
   * @returns Area
   * @throws ApiError
   */
  public siteAreasCreate(
    id: string,
    requestBody: AreaData,
  ): CancelablePromise<Area> {
    return this.httpRequest.request({
      method: "POST",
      url: "/sites/{id}/areas",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Get area for site
   * Get a details of a single area for site
   * @param areaId Site id
   * @param siteId Site id
   * @returns Area
   * @throws ApiError
   */
  public siteAreaGet(
    areaId: string,
    siteId: string,
  ): CancelablePromise<Area> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{site_id}/areas/{area_id}",
      path: {
        "area_id": areaId,
        "site_id": siteId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Areas update
   * Update an area in a site
   * @param areaId Site id
   * @param siteId Site id
   * @param requestBody
   * @returns Area
   * @throws ApiError
   */
  public siteAreasUpdate(
    areaId: string,
    siteId: string,
    requestBody: AreaData,
  ): CancelablePromise<Area> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{site_id}/areas/{area_id}",
      path: {
        "area_id": areaId,
        "site_id": siteId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Connections get for a site
   * Get Connections for a site
   * @param id Site id
   * @returns SiteConnections
   * @throws ApiError
   */
  public siteConnectionsGet(
    id: string,
  ): CancelablePromise<SiteConnections> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/connections",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Connections put for a site
   * Update Connections for a site
   * @param id Site id
   * @param requestBody
   * @returns SiteConnections
   * @throws ApiError
   */
  public siteConnectionsPut(
    id: string,
    requestBody: SiteConnections,
  ): CancelablePromise<SiteConnections> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{id}/connections",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site RentalInfo get
   * Get RentalInfo for Site
   * @param id Site id
   * @returns RentalInfo
   * @throws ApiError
   */
  public siteRentalInfoGet(
    id: string,
  ): CancelablePromise<RentalInfo> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/rental_info",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site RentalInfo update
   * Update RentalInfo for Site
   * @param id Site id
   * @param requestBody
   * @returns RentalInfo
   * @throws ApiError
   */
  public siteRentalInfoPut(
    id: string,
    requestBody: RentalInfoData,
  ): CancelablePromise<RentalInfo> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{id}/rental_info",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site LenderInfo get
   * Get LenderInfo for Site
   * @param id Site id
   * @returns LenderInfo
   * @throws ApiError
   */
  public siteLenderInfoGet(
    id: string,
  ): CancelablePromise<LenderInfo> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/lender_info",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site LenderInfo update
   * Update LenderInfo for Site
   * @param id Site id
   * @param requestBody
   * @returns LenderInfo
   * @throws ApiError
   */
  public siteLenderInfoPut(
    id: string,
    requestBody: LenderInfoData,
  ): CancelablePromise<LenderInfo> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{id}/lender_info",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site get stats
   * Get overview stats
   * @param id Site id
   * @returns SiteStats
   * @throws ApiError
   */
  public siteGetStats(
    id: string,
  ): CancelablePromise<SiteStats> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/stats",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site AgreementSettings get
   * Get AgreementSettings for a site
   * @param id Site id
   * @returns AgreementSettings
   * @throws ApiError
   */
  public siteGetAgreementSettings(
    id: string,
  ): CancelablePromise<AgreementSettings> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/agreement_settings",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site AgreementSettings set
   * Set AgreementSettings for a site
   * @param id Site id
   * @param requestBody
   * @returns AgreementSettings
   * @throws ApiError
   */
  public siteSetAgreementSettings(
    id: string,
    requestBody: AgreementSettingsData,
  ): CancelablePromise<AgreementSettings> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{id}/agreement_settings",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Devices by site
   * Get all devices for a site
   * @param id Site id
   * @returns Device
   * @throws ApiError
   */
  public siteGetDevices(
    id: string,
  ): CancelablePromise<Array<Device>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/devices",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spots by site
   * Get all spots in a site
   * @param id Site id
   * @returns Spot
   * @throws ApiError
   */
  public siteGetSpots(
    id: string,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/spots",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site get queue
   * Get sites Queue
   * @param id Site id
   * @returns Queue
   * @throws ApiError
   */
  public siteGetQueue(
    id: string,
  ): CancelablePromise<Queue> {
    return this.httpRequest.request({
      method: "GET",
      url: "/sites/{id}/queue",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site connect Creditor
   * Connect a Creditor to the given site
   * @param id Site id
   * @param requestBody
   * @returns BillectaCreditor
   * @throws ApiError
   */
  public siteConnectCreditor(
    id: string,
    requestBody: string,
  ): CancelablePromise<BillectaCreditor> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/sites/{id}/creditor",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Site disconnect Creditor
   * Disconnect creditor from the given site
   * @param id Site id
   * @returns any no content
   * @throws ApiError
   */
  public siteDisconnectCreditor(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/sites/{id}/creditor",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Public site search
   * Site search for the public, no jwt requried.
   * @param requestBody
   * @returns Paginated_for_PublicSiteRow
   * @throws ApiError
   */
  public publicSiteSearch(
    requestBody: PublicSearchSites,
  ): CancelablePromise<Paginated_for_PublicSiteRow> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/store/sites/search",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Public site get
   * Get a site by id, no jwt required. Only public sites will be returned.
   * @param id Site id
   * @returns Site
   * @throws ApiError
   */
  public publicSiteGet(
    id: string,
  ): CancelablePromise<Site> {
    return this.httpRequest.request({
      method: "GET",
      url: "/public/store/sites/{id}",
      path: {
        "id": id,
      },
    });
  }
  /**
   * Public site get queue
   * Get sites Queue without jwt
   * @param id Site id
   * @returns Queue
   * @throws ApiError
   */
  public publicSiteGetQueue(
    id: string,
  ): CancelablePromise<Queue> {
    return this.httpRequest.request({
      method: "GET",
      url: "/public/store/sites/{id}/queue",
      path: {
        "id": id,
      },
    });
  }
  /**
   * Public search for spot classes
   * @param requestBody
   * @returns SpotClass
   * @throws ApiError
   */
  public publicSearchSpotClasses(
    requestBody: PublicSearchSpotClasses,
  ): CancelablePromise<Array<SpotClass>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/store/spot-classes/search",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Search for spot classes
   * @param requestBody
   * @returns Spot
   * @throws ApiError
   */
  public publicSpotclassGetSpots(
    requestBody: SpotClassSpotSearch,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/store/spot-classes/spots",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Public Spots search
   * Public spot search, no jwt required.
   * @param requestBody
   * @returns SearchResponse_for_MyPagesSpot
   * @throws ApiError
   */
  public publicSearchSpots(
    requestBody: SearchSpots,
  ): CancelablePromise<SearchResponse_for_MyPagesSpot> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/store/spots/search",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Debtor get
   * Get a debtor by id
   * @param id Debtor id
   * @param requestBody
   * @returns DebtorWithPaymentCards
   * @throws ApiError
   */
  public publicDebtorAndCardsGet(
    id: string,
    requestBody: AuthToken,
  ): CancelablePromise<DebtorWithPaymentCards> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/debtor/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Debtor setup new Payment card
   * Setup a new card for a Debtor
   * @param id Debtor id
   * @param requestBody
   * @returns PaymentCardSetup
   * @throws ApiError
   */
  public publicDebtorSetupCard(
    id: string,
    requestBody: AuthToken,
  ): CancelablePromise<PaymentCardSetup> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/debtor/{id}/cards",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Debtor finalize card setup
   * Finalize card setup for a debtor
   * @param debtorId Debtor id
   * @param setupId Setup id
   * @param requestBody
   * @returns PaymentCard
   * @throws ApiError
   */
  public publicDebtorFinalizeCardSetup(
    debtorId: string,
    setupId: string,
    requestBody: FinalizePaymentCardSetupWithAuthToken,
  ): CancelablePromise<PaymentCard> {
    return this.httpRequest.request({
      method: "POST",
      url: "/public/debtor/{debtorId}/cards/setup/{setupId}",
      path: {
        "debtorId": debtorId,
        "setupId": setupId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Site p46Import
   * import a site from park46
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public siteP46Import(
    requestBody: ImportP46Site,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/import/p46",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Import agreements in csv format
   * Import agreements for a site
   * @param id Site id
   * @param requestBody
   * @param agreementPeriod
   * @param invoicingStart
   * @param noticePeriod
   * @param offerNoticePeriod
   * @returns CsvImportOutcome
   * @throws ApiError
   */
  public siteAgreementsImport(
    id: string,
    requestBody: any,
    agreementPeriod?: Months | null,
    invoicingStart?: Date | null,
    noticePeriod?: Months | null,
    offerNoticePeriod?: Days | null,
  ): CancelablePromise<CsvImportOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/import/site_agreements/{id}",
      path: {
        "id": id,
      },
      query: {
        "agreementPeriod": agreementPeriod,
        "invoicingStart": invoicingStart,
        "noticePeriod": noticePeriod,
        "offerNoticePeriod": offerNoticePeriod,
      },
      body: requestBody,
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Rollback of imports
   * Rollback a previous import
   * @param importId
   * @returns any no content
   * @throws ApiError
   */
  public importRollback(
    importId: number,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/import/rollback/{importId}",
      path: {
        "importId": importId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns Paginated_for_ClientRow
   * @throws ApiError
   */
  public searchClients(
    requestBody: SearchClients,
  ): CancelablePromise<Paginated_for_ClientRow> {
    return this.httpRequest.request({
      method: "POST",
      url: "/clients",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot get
   * Get a single spot
   * @param id Spot id
   * @returns Spot
   * @throws ApiError
   */
  public getSpot(
    id: string,
  ): CancelablePromise<Spot> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spots/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot update
   * Update a spot
   * @param id Spot id
   * @param requestBody
   * @returns Spot
   * @throws ApiError
   */
  public putSpot(
    id: string,
    requestBody: SpotData,
  ): CancelablePromise<Spot> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/spots/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot get agreements
   * Get all agreements for this spot
   * @param id Spot id
   * @returns Agreement
   * @throws ApiError
   */
  public getSpotAgreements(
    id: string,
  ): CancelablePromise<Array<Agreement>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spots/{id}/agreements",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Validate access code for the spot
   * @param id Spot id
   * @param requestBody
   * @returns ValidateAccessCode
   * @throws ApiError
   */
  public validateAccessCode(
    id: string,
    requestBody: ValidateAccessCode,
  ): CancelablePromise<ValidateAccessCode> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spots/{id}/validate_acces_code",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * Spot get shares
   * Get all shares for this spot
   * @param id Spot id
   * @returns SpotShare
   * @throws ApiError
   */
  public getSpotShares(
    id: string,
  ): CancelablePromise<Array<SpotShare>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spots/{id}/shares",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot group get
   * Get all spots grouped in this spot
   * @param id Spot id
   * @returns Spot
   * @throws ApiError
   */
  public getSpotGroup(
    id: string,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spots/{id}/group",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot get tags
   * Get tags of a spot
   * @param id Spot id
   * @returns Tag
   * @throws ApiError
   */
  public getSpotTags(
    id: string,
  ): CancelablePromise<Array<Tag>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spots/{id}/tags",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot add tags
   * Adds tags to a spot
   * @param id Spot id
   * @param requestBody
   * @returns Tag
   * @throws ApiError
   */
  public addSpotTags(
    id: string,
    requestBody: TagIds,
  ): CancelablePromise<Array<Tag>> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/spots/{id}/tags",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot delete tags
   * Deletes tags from a spot
   * @param id Spot id
   * @param requestBody
   * @returns Tag
   * @throws ApiError
   */
  public deleteSpotTags(
    id: string,
    requestBody: TagIds,
  ): CancelablePromise<Array<Tag>> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/spots/{id}/tags",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spot get applicants
   * Get any applicants matching this spot
   * @param id Spot id
   * @returns QueueApplicant
   * @throws ApiError
   */
  public getSpotApplicants(
    id: string,
  ): CancelablePromise<Array<QueueApplicant>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spots/{id}/applicants",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spots search
   * Paginated search of spots
   * @param requestBody
   * @returns SearchResponse_for_Spot
   * @throws ApiError
   */
  public searchSpots(
    requestBody: SearchSpots2,
  ): CancelablePromise<SearchResponse_for_Spot> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spots/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spots batch update
   * Update multiple spots
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public batchUpdateSpots(
    requestBody: SpotBatchUpdate,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/spots/batch",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spots batch create
   * Create multiple spots
   * @param requestBody
   * @returns Spot
   * @throws ApiError
   */
  public batchCreateSpots(
    requestBody: SpotBatchCreate,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spots/batch",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spots batch delete
   * Delete multiple spots
   * @param requestBody
   * @returns Spot
   * @throws ApiError
   */
  public batchDeleteSpots(
    requestBody: Array<string>,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/spots/batch",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Spots group
   * Group multiple spots
   * @param requestBody
   * @returns CreatedSpotGroup
   * @throws ApiError
   */
  public createSpotGroup(
    requestBody: CreateSpotGroup,
  ): CancelablePromise<CreatedSpotGroup> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spots/group",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Areas set for spots
   * Set area for many spots
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public spotsSetArea(
    requestBody: SpotsSetArea,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spots/area",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag create
   * Create a new tag
   * @param requestBody
   * @returns Tag
   * @throws ApiError
   */
  public createTag(
    requestBody: TagData,
  ): CancelablePromise<Tag> {
    return this.httpRequest.request({
      method: "POST",
      url: "/tags",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag get
   * Get a tag with any connected spots
   * @param id Tag id
   * @returns TagWithAssociations
   * @throws ApiError
   */
  public getTag(
    id: string,
  ): CancelablePromise<TagWithAssociations> {
    return this.httpRequest.request({
      method: "GET",
      url: "/tags/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag update
   * Update a tag
   * @param id Tag id
   * @param requestBody
   * @returns Tag
   * @throws ApiError
   */
  public putTag(
    id: string,
    requestBody: TagData,
  ): CancelablePromise<Tag> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/tags/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag delete
   * Deletes a tag
   * @param id Tag id
   * @returns Tag
   * @throws ApiError
   */
  public deleteTag(
    id: string,
  ): CancelablePromise<Tag> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/tags/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag get entrances
   * Get all entrances connected to a Tag
   * @param id Tag id
   * @returns Entrance
   * @throws ApiError
   */
  public getTagEntrances(
    id: string,
  ): CancelablePromise<Array<Entrance>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/tags/{id}/entrances",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag set entrances
   * Set entrances to connect to a Tag
   * @param id Tag id
   * @param requestBody
   * @returns Entrance
   * @throws ApiError
   */
  public setTagEntrances(
    id: string,
    requestBody: EntranceIds,
  ): CancelablePromise<Array<Entrance>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/tags/{id}/entrances",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag set terms
   * Get the terms of a tag
   * @param id Tag id
   * @returns any
   * @throws ApiError
   */
  public getTagTerms(
    id: string,
  ): CancelablePromise<(Terms | null)> {
    return this.httpRequest.request({
      method: "GET",
      url: "/tags/{id}/terms",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Tag set terms
   * Set terms for a tag
   * @param id Tag id
   * @param requestBody
   * @returns Terms
   * @throws ApiError
   */
  public setTagTerms(
    id: string,
    requestBody: string | null,
  ): CancelablePromise<Terms> {
    return this.httpRequest.request({
      method: "POST",
      url: "/tags/{id}/terms",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Product get
   * Get a product by ID
   * @param id Product id
   * @returns Product
   * @throws ApiError
   */
  public productGet(
    id: string,
  ): CancelablePromise<Product> {
    return this.httpRequest.request({
      method: "GET",
      url: "/products/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Product put
   * Update a product by ID
   * @param id Product id
   * @param requestBody
   * @returns Product
   * @throws ApiError
   */
  public productPut(
    id: string,
    requestBody: ProductData,
  ): CancelablePromise<Product> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/products/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Products search
   * Paginated search of products
   * @param requestBody
   * @returns Paginated_for_ProductRow
   * @throws ApiError
   */
  public productsSearch(
    requestBody: ProductSearch,
  ): CancelablePromise<Paginated_for_ProductRow> {
    return this.httpRequest.request({
      method: "POST",
      url: "/products/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Products delete
   * Delete multiple products
   * @param requestBody
   * @returns Product
   * @throws ApiError
   */
  public productsDelete(
    requestBody: Array<string>,
  ): CancelablePromise<Array<Product>> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/products/delete",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Product create
   * Create a product
   * @param requestBody
   * @returns Product
   * @throws ApiError
   */
  public productCreate(
    requestBody: ProductData,
  ): CancelablePromise<Product> {
    return this.httpRequest.request({
      method: "POST",
      url: "/products",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor search
   * Paginated search of debtors
   * @param requestBody
   * @returns SearchResponse_for_IndexedDebtor
   * @throws ApiError
   */
  public debtorSearch(
    requestBody: SearchDebtors,
  ): CancelablePromise<SearchResponse_for_IndexedDebtor> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor batch delete
   * Batch delete debtors
   * @param requestBody
   * @returns DebtorBatchDeleteResult
   * @throws ApiError
   */
  public debtorBatchDelete(
    requestBody: DebtorIds,
  ): CancelablePromise<DebtorBatchDeleteResult> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/debtors/batch",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor create
   * Create a new debtor
   * @param requestBody
   * @returns Debtor
   * @throws ApiError
   */
  public debtorCreate(
    requestBody: DebtorData,
  ): CancelablePromise<Debtor> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get
   * Get a debtor by id
   * @param id Debtor id
   * @returns Debtor
   * @throws ApiError
   */
  public debtorGet(
    id: string,
  ): CancelablePromise<Debtor> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor update
   * Update a debtor by id
   * @param id Debtor id
   * @param requestBody
   * @returns Debtor
   * @throws ApiError
   */
  public debtorPut(
    id: string,
    requestBody: DebtorData,
  ): CancelablePromise<Debtor> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/debtors/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor delete
   * Delete a debtor by id
   * @param id Debtor id
   * @returns DebtorDeleteResult
   * @throws ApiError
   */
  public debtorDelete(
    id: string,
  ): CancelablePromise<DebtorDeleteResult> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/debtors/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get cards
   * Get cards for Debtor
   * @param id Debtor id
   * @returns PaymentCard
   * @throws ApiError
   */
  public debtorGetCards(
    id: string,
  ): CancelablePromise<Array<PaymentCard>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/cards",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor setup new Payment card
   * Setup a new card for a Debtor
   * @param id Debtor id
   * @returns PaymentCardSetup
   * @throws ApiError
   */
  public debtorSetupCard(
    id: string,
  ): CancelablePromise<PaymentCardSetup> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{id}/cards",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor delete card
   * Deleta a payment card for a debtor
   * @param cardId Card id
   * @param debtorId Debtor id
   * @returns any no content
   * @throws ApiError
   */
  public debtorDeleteCard(
    cardId: string,
    debtorId: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{debtorId}/cards/{cardId}",
      path: {
        "cardId": cardId,
        "debtorId": debtorId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor set default
   * Debtor set default payment card
   * @param cardId Card id
   * @param debtorId Debtor id
   * @returns any no content
   * @throws ApiError
   */
  public debtorSetDefaultCard(
    cardId: string,
    debtorId: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/debtors/{debtorId}/cards/{cardId}",
      path: {
        "cardId": cardId,
        "debtorId": debtorId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor finalize card setup
   * Finalize card setup for a debtor
   * @param debtorId Debtor id
   * @param setupId Setup id
   * @param requestBody
   * @returns PaymentCard
   * @throws ApiError
   */
  public debtorFinalizeCardSetup(
    debtorId: string,
    setupId: string,
    requestBody: FinalizePaymentCardSetup,
  ): CancelablePromise<PaymentCard> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{debtorId}/cards/setup/{setupId}",
      path: {
        "debtorId": debtorId,
        "setupId": setupId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get delivery method
   * Get delivery method for Debtor
   * @param id Debtor id
   * @returns DebtorDeliveryMethod
   * @throws ApiError
   */
  public debtorGetDeliveryMethod(
    id: string,
  ): CancelablePromise<DebtorDeliveryMethod> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/delivery_method",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor set delivery method
   * Set delivery method for Debtor
   * @param id Debtor id
   * @param requestBody
   * @returns DebtorDeliveryMethod
   * @throws ApiError
   */
  public debtorSetDeliveryMethod(
    id: string,
    requestBody: DebtorDeliveryMethod,
  ): CancelablePromise<DebtorDeliveryMethod> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/debtors/{id}/delivery_method",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get payment method
   * Get payment method for Debtor
   * @param id Debtor id
   * @returns DebtorPaymentMethod
   * @throws ApiError
   */
  public debtorGetPaymentMethod(
    id: string,
  ): CancelablePromise<DebtorPaymentMethod> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/payment_method",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor set payment method
   * Set payment method for Debtor
   * @param id Debtor id
   * @param requestBody
   * @returns DebtorPaymentMethod
   * @throws ApiError
   */
  public debtorSetPaymentMethod(
    id: string,
    requestBody: DebtorPaymentMethod,
  ): CancelablePromise<DebtorPaymentMethod> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/debtors/{id}/payment_method",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get agreements
   * Get all agreements for a debtor
   * @param id Debtor id
   * @returns Agreement
   * @throws ApiError
   */
  public debtorGetAgreements(
    id: string,
  ): CancelablePromise<Array<Agreement>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/agreements",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get users
   * Get users with access to a debtor
   * @param id Debtor id
   * @returns DebtorUser
   * @throws ApiError
   */
  public debtorGetUsers(
    id: string,
  ): CancelablePromise<Array<DebtorUser>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/users",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor add user
   * Add or update user access to debtor
   * @param id Debtor id
   * @param requestBody
   * @returns DebtorUser
   * @throws ApiError
   */
  public debtorAddUser(
    id: string,
    requestBody: CreateDebtorUser,
  ): CancelablePromise<DebtorUser> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{id}/users",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor remove users
   * Remove users with access to a debtor
   * @param id Debtor id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public debtorRemoveUsers(
    id: string,
    requestBody: UserIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/debtors/{id}/users",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Resend user invite
   * Send the user invite email again
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public resendUserInvite(
    requestBody: Id,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/resend_user_invite",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get applicants
   * Get all applicants for Debtor
   * @param id Debtor id
   * @returns QueueApplicantRef
   * @throws ApiError
   */
  public debtorGetApplicants(
    id: string,
  ): CancelablePromise<Array<QueueApplicantRef>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/applicants",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get invoices
   * Get invoices created for this Debtor
   * @param id Debtor id
   * @param page
   * @param pageSize
   * @returns DebtorInvoiceSub
   * @throws ApiError
   */
  public debtorGetInvoices(
    id: string,
    page: number,
    pageSize: number,
  ): CancelablePromise<Array<DebtorInvoiceSub>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{id}/invoices",
      path: {
        "id": id,
      },
      query: {
        "page": page,
        "pageSize": pageSize,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Debtor get invoice PDF
   * Gets an Invoice for a Debtor as PDF
   * @param debtorId Debtor id
   * @param invoiceId
   * @returns Base64 Base64
   * @throws ApiError
   */
  public debtorGetInvoicePdf(
    debtorId: string,
    invoiceId: number,
  ): CancelablePromise<Base64> {
    return this.httpRequest.request({
      method: "GET",
      url: "/debtors/{debtorId}/invoices/{invoiceId}/pdf",
      path: {
        "debtorId": debtorId,
        "invoiceId": invoiceId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Request the debtor to fill in a payment card
   * An email will be sent to the debtor
   * @param id Debtor id
   * @returns any no content
   * @throws ApiError
   */
  public debtorRequestPaymentCard(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{id}/request-payment-card",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * List debtor payments
   * List debtor payments
   * @param id Debtor id
   * @param requestBody
   * @returns Paginated_for_Payment
   * @throws ApiError
   */
  public debtorListPayments(
    id: string,
    requestBody: SearchPayments,
  ): CancelablePromise<Paginated_for_Payment> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{id}/payments/search",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Send Receipt for a Payment
   * Send payment receipt
   * @param debtorId Debtor id
   * @param paymentId Payment id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public debtorSendPaymentReceipt(
    debtorId: string,
    paymentId: string,
    requestBody: PostPaymentReceipt,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{debtor_id}/payments/{payment_id}/receipt",
      path: {
        "debtor_id": debtorId,
        "payment_id": paymentId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Refund payment
   * Refund payment
   * @param debtorId Debtor id
   * @param paymentId Payment id
   * @returns any no content
   * @throws ApiError
   */
  public debtorRefundPayment(
    debtorId: string,
    paymentId: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/debtors/{debtor_id}/payments/{payment_id}/refund",
      path: {
        "debtor_id": debtorId,
        "payment_id": paymentId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement create
   * Create a new agreement
   * @param requestBody
   * @returns AgreementUpdateResult
   * @throws ApiError
   */
  public createAgreement(
    requestBody: AgreementUpdate,
  ): CancelablePromise<AgreementUpdateResult> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement search
   * Searches for agreements
   * @param requestBody
   * @returns SearchResponse_for_Agreement
   * @throws ApiError
   */
  public searchAgreements(
    requestBody: SearchAgreements,
  ): CancelablePromise<SearchResponse_for_Agreement> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreements Pre Approve
   * Pre approve multiple agreements
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public preApproveAgreements(
    requestBody: AgreementIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/preapprove",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreements Reset to Draft
   * Reset multiple agreements to Draft
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public resetAgreementsToDraft(
    requestBody: AgreementIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/reset-to-draft",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement offer to debtor
   * Offer an agreement to a debtor
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public offerAgreement(
    requestBody: AgreementIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/offer",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreements end
   * Set the end date of multiple agreements
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public endAgreements(
    requestBody: AgreementsWithEndDate,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/end",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreements delete
   * Delete multiple agreements
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public deleteAgreements(
    requestBody: AgreementIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/delete",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement get
   * Get an agreement
   * @param id Agreement id
   * @returns Agreement
   * @throws ApiError
   */
  public getAgreement(
    id: string,
  ): CancelablePromise<Agreement> {
    return this.httpRequest.request({
      method: "GET",
      url: "/agreements/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement update
   * Update an agreement draft
   * @param id Agreement id
   * @param requestBody
   * @returns AgreementUpdateResult
   * @throws ApiError
   */
  public updateAgreement(
    id: string,
    requestBody: AgreementUpdate,
  ): CancelablePromise<AgreementUpdateResult> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/agreements/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement get Shares
   * Get all shares via this agreement
   * @param id Agreement id
   * @returns SpotShare
   * @throws ApiError
   */
  public getAgreementShares(
    id: string,
  ): CancelablePromise<Array<SpotShare>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/agreements/{id}/shares",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement get Pdf
   * Download the agreement as a Pdf
   * @param id Agreement id
   * @returns Base64 Base64
   * @throws ApiError
   */
  public getAgreementPdf(
    id: string,
  ): CancelablePromise<Base64> {
    return this.httpRequest.request({
      method: "GET",
      url: "/agreements/{id}/pdf",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement set Pdf
   * Upload a new PDF for this agreement
   * @param id Agreement id
   * @param requestBody Base64
   * @returns any no content
   * @throws ApiError
   */
  public setAgreementPdf(
    id: string,
    requestBody: Base64,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/{id}/pdf",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement get additional Terms
   * Get the additional terms of an agreement
   * @param id Agreement id
   * @returns any
   * @throws ApiError
   */
  public getAgreementAdditionalTerms(
    id: string,
  ): CancelablePromise<(Terms | null)> {
    return this.httpRequest.request({
      method: "GET",
      url: "/agreements/{id}/additional_terms",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement set additional Terms
   * Set additional terms for an agreement
   * @param id Agreement id
   * @param requestBody
   * @returns Terms
   * @throws ApiError
   */
  public setAgreementAdditionalTerms(
    id: string,
    requestBody: string | null,
  ): CancelablePromise<Terms> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/{id}/additional_terms",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement get full Terms
   * Get the full terms for an agreement. Site terms + tag terms + agreement terms
   * @param id Agreement id
   * @returns Terms
   * @throws ApiError
   */
  public getAgreementFullTerms(
    id: string,
  ): CancelablePromise<Array<Terms>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/agreements/{id}/full_terms",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Agreement reply to Offer
   * Reply to an offered Agreement
   * @param id Agreement id
   * @param requestBody A reply to an offerred agreement.
   * @returns Agreement
   * @throws ApiError
   */
  public replyToAgreementOffer(
    id: string,
    requestBody: AgreementOfferReply,
  ): CancelablePromise<Agreement> {
    return this.httpRequest.request({
      method: "POST",
      url: "/agreements/{id}/offer/reply",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Park46 search Debtors
   * Search debtors in Par46
   * @param requestBody
   * @returns SearchResponse_for_P46Debtor
   * @throws ApiError
   */
  public park46SearchDebtors(
    requestBody: SearchP46Debtors,
  ): CancelablePromise<SearchResponse_for_P46Debtor> {
    return this.httpRequest.request({
      method: "POST",
      url: "/park46/debtors",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Park46 search Sites
   * Search sites in Par46
   * @param requestBody
   * @returns SearchResponse_for_P46Site
   * @throws ApiError
   */
  public park46SearchSites(
    requestBody: SearchP46Sites,
  ): CancelablePromise<SearchResponse_for_P46Site> {
    return this.httpRequest.request({
      method: "POST",
      url: "/park46/sites",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Device create
   * Creates a new Device
   * @param requestBody
   * @returns Device
   * @throws ApiError
   */
  public createDevice(
    requestBody: DeviceData,
  ): CancelablePromise<Device> {
    return this.httpRequest.request({
      method: "POST",
      url: "/devices",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Device delete many
   * Deletes multiple devices
   * @param requestBody
   * @returns Device
   * @throws ApiError
   */
  public deleteDevices(
    requestBody: Array<string>,
  ): CancelablePromise<Array<Device>> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/devices/bulk",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Device get
   * Get a device with by id
   * @param id Device id
   * @returns Device
   * @throws ApiError
   */
  public getDevice(
    id: string,
  ): CancelablePromise<Device> {
    return this.httpRequest.request({
      method: "GET",
      url: "/devices/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Device update
   * Update a device
   * @param id Device id
   * @param requestBody
   * @returns Device
   * @throws ApiError
   */
  public putDevice(
    id: string,
    requestBody: DeviceData,
  ): CancelablePromise<Device> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/devices/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Device actuate
   * Actuate a remote device with device id
   * @param id Device id
   * @returns any no content
   * @throws ApiError
   */
  public actuateDevice(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/devices/{id}/actuate",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrace create
   * Creates a new Entrance
   * @param requestBody
   * @returns Entrance
   * @throws ApiError
   */
  public createEntrance(
    requestBody: NewEntrance,
  ): CancelablePromise<Entrance> {
    return this.httpRequest.request({
      method: "POST",
      url: "/entrances",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrace search
   * Search entrances
   * @param requestBody
   * @returns Paginated_for_Entrance
   * @throws ApiError
   */
  public searchEntrance(
    requestBody: SearchEntrances,
  ): CancelablePromise<Paginated_for_Entrance> {
    return this.httpRequest.request({
      method: "POST",
      url: "/entrances/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance get
   * Get an entrance by id
   * @param id Entrance id
   * @returns Entrance
   * @throws ApiError
   */
  public getEntrance(
    id: string,
  ): CancelablePromise<Entrance> {
    return this.httpRequest.request({
      method: "GET",
      url: "/entrances/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance update
   * Update an entrance
   * @param id Entrance id
   * @param requestBody
   * @returns Entrance
   * @throws ApiError
   */
  public putEntrance(
    id: string,
    requestBody: EntranceData,
  ): CancelablePromise<Entrance> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/entrances/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance delete
   * Deletes an entrance by id
   * @param id Entrance id
   * @returns any no content
   * @throws ApiError
   */
  public deleteEntrance(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/entrances/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance get tags
   * Get all tags connected to a entrance
   * @param id Entrance id
   * @returns Tag
   * @throws ApiError
   */
  public getEntranceTags(
    id: string,
  ): CancelablePromise<Array<Tag>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/entrances/{id}/tags",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance set tags
   * Set tags connected to entrance
   * @param id Entrance id
   * @param requestBody
   * @returns Tag
   * @throws ApiError
   */
  public setEntranceTags(
    id: string,
    requestBody: TagIds,
  ): CancelablePromise<Array<Tag>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/entrances/{id}/tags",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance get devices
   * Get all devices connected to a entrance
   * @param id Entrance id
   * @returns Device
   * @throws ApiError
   */
  public getEntranceDevices(
    id: string,
  ): CancelablePromise<Array<Device>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/entrances/{id}/devices",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Entrance set devices
   * Set devices connected to entrance
   * @param id Entrance id
   * @param requestBody
   * @returns Device
   * @throws ApiError
   */
  public setEntranceDevices(
    id: string,
    requestBody: DeviceIds,
  ): CancelablePromise<Array<Device>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/entrances/{id}/devices",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SpotShare search
   * Search all spot shares
   * @param requestBody
   * @returns Paginated_for_SpotShare
   * @throws ApiError
   */
  public searchSpotShares(
    requestBody: SearchSpotShares,
  ): CancelablePromise<Paginated_for_SpotShare> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spot_shares/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SpotShare accept
   * Accept a Shared spot
   * @param id SpotShare id
   * @param requestBody
   * @returns SpotShare
   * @throws ApiError
   */
  public acceptSpotShare(
    id: string,
    requestBody: string,
  ): CancelablePromise<SpotShare> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spot_shares/{id}/accept",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SpotShare Get
   * Get a SpotShare
   * @param id SpotShare id
   * @returns SpotShare
   * @throws ApiError
   */
  public getSpotShare(
    id: string,
  ): CancelablePromise<SpotShare> {
    return this.httpRequest.request({
      method: "GET",
      url: "/spot_shares/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SpotShare update
   * Update a tag
   * @param id SpotShare id
   * @param requestBody
   * @returns SpotShare
   * @throws ApiError
   */
  public updateSpotShare(
    id: string,
    requestBody: UpdateSpotShare,
  ): CancelablePromise<SpotShare> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/spot_shares/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SpotShare delete
   * Deletes a previously shared Spot
   * @param id SpotShare id
   * @returns any no content
   * @throws ApiError
   */
  public deleteSpotShare(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/spot_shares/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SpotShare Create
   * Create a new spot share
   * @param requestBody
   * @returns SpotShare
   * @throws ApiError
   */
  public createSpotShare(
    requestBody: CreateSpotShare,
  ): CancelablePromise<SpotShare> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spot_shares",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue get
   * Get a queue
   * @param id Queue id
   * @returns Queue
   * @throws ApiError
   */
  public queueGet(
    id: string,
  ): CancelablePromise<Queue> {
    return this.httpRequest.request({
      method: "GET",
      url: "/queues/{id}",
      path: {
        "id": id,
      },
    });
  }
  /**
   * Queue update
   * Queue Update
   * @param id Queue id
   * @param requestBody
   * @returns Queue
   * @throws ApiError
   */
  public queuePut(
    id: string,
    requestBody: QueueData,
  ): CancelablePromise<Queue> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/queues/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue get Availability
   * Get availability given a list of selected tags
   * @param id Queue id
   * @param requestBody
   * @returns QueueTagsAvailability
   * @throws ApiError
   */
  public queueGetAvailability(
    id: string,
    requestBody: SearchQueueTags,
  ): CancelablePromise<QueueTagsAvailability> {
    return this.httpRequest.request({
      method: "POST",
      url: "/queues/{id}/availability",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue search Spots
   * Search spots in queue
   * @param id Queue id
   * @param requestBody
   * @returns Paginated_for_MyPagesSpot
   * @throws ApiError
   */
  public queueSearchSpots(
    id: string,
    requestBody: SearchSpots3,
  ): CancelablePromise<Paginated_for_MyPagesSpot> {
    return this.httpRequest.request({
      method: "POST",
      url: "/queues/{id}/spots",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * QueueStep Create
   * Create a new Queue Step
   * @param id Queue id
   * @param requestBody
   * @returns QueueStep
   * @throws ApiError
   */
  public queueStepCreate(
    id: string,
    requestBody: QueueStepData,
  ): CancelablePromise<QueueStep> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/queues/{id}/steps",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * QueueStep Update
   * Update a Queue Step
   * @param queueId Queue id
   * @param stepId Step id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public queueStepUpdate(
    queueId: string,
    stepId: string,
    requestBody: QueueStepData,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/queues/{queueId}/steps/{stepId}",
      path: {
        "queueId": queueId,
        "stepId": stepId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * QueueStep Delete
   * Delete a Queue Step
   * @param queueId Queue id
   * @param stepId Step id
   * @returns any no content
   * @throws ApiError
   */
  public queueStepDelete(
    queueId: string,
    stepId: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/queues/{queueId}/steps/{stepId}",
      path: {
        "queueId": queueId,
        "stepId": stepId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue Step Set tags
   * Set tags associatied to a queue step
   * @param queueId Queue id
   * @param stepId Step id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public queueStepSetTags(
    queueId: string,
    stepId: string,
    requestBody: Array<QueueStepTag>,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/queues/{queueId}/steps/{stepId}/tags",
      path: {
        "queueId": queueId,
        "stepId": stepId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue get Applicants
   * Get all applicants for a queue
   * @param id Queue id
   * @returns QueueApplicant
   * @throws ApiError
   */
  public queueGetApplicants(
    id: string,
  ): CancelablePromise<Array<QueueApplicant>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/queues/{id}/applicants",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue add Applicant
   * Add an Applicant to a queue
   * @param id Queue id
   * @param requestBody
   * @returns QueueApplicant
   * @throws ApiError
   */
  public queuePostApplicant(
    id: string,
    requestBody: NewQueueApplicant,
  ): CancelablePromise<QueueApplicant> {
    return this.httpRequest.request({
      method: "POST",
      url: "/queues/{id}/applicants",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue delete multiple Applicants
   * Delete multiple applicants from the queue
   * @param id Queue id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public queueBulkDeleteApplicants(
    id: string,
    requestBody: Array<string>,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/queues/{id}/applicants",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue get an Applicant
   * Get an Applicant in a queue
   * @param id Applicant id
   * @returns QueueApplicant
   * @throws ApiError
   */
  public queueGetApplicant(
    id: string,
  ): CancelablePromise<QueueApplicant> {
    return this.httpRequest.request({
      method: "GET",
      url: "/queues/applicants/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue update an Applicant
   * Update an Applicant in a queue
   * @param id Applicant id
   * @param requestBody
   * @returns QueueApplicant
   * @throws ApiError
   */
  public queueUpdateApplicant(
    id: string,
    requestBody: QueueApplicantData,
  ): CancelablePromise<QueueApplicant> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/queues/applicants/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue remove Applicant
   * Remove an Applicant from a queue
   * @param id Applicant id
   * @returns any no content
   * @throws ApiError
   */
  public queueDeleteApplicant(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/queues/applicants/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue Applicant get matching spots
   * Get matching spots for an applicant
   * @param id Applicant id
   * @returns Spot
   * @throws ApiError
   */
  public queueApplicantMatchingSpots(
    id: string,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/queues/applicants/{id}/matching_spots",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue Applicant set debtor id
   * Sets the debtor of the applicant. The account must have admin rights for the debtor.
   * @param id Applicant id
   * @param requestBody
   * @returns QueueApplicant
   * @throws ApiError
   */
  public applicantSetDebtor(
    id: string,
    requestBody: DebtorId2,
  ): CancelablePromise<QueueApplicant> {
    return this.httpRequest.request({
      method: "POST",
      url: "/queues/applicants/{id}/debtor",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Queue Applicants send info requests
   * Send info requests to the provided applicants
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public queueApplicantsInfoRequest(
    requestBody: ApplicantIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/queues/applicants/send-info-request",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Creditors get all
   * Get all creditors, including from Billecta
   * @returns BillectaCreditorRef
   * @throws ApiError
   */
  public getAllCreditors(): CancelablePromise<Array<BillectaCreditorRef>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/creditors/all",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Creditor get
   * Get a creditor by id
   * @param id Creditor id
   * @returns any
   * @throws ApiError
   */
  public getCreditor(
    id: string,
  ): CancelablePromise<(BillectaCreditor | null)> {
    return this.httpRequest.request({
      method: "GET",
      url: "/creditors/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Creditor update
   * Update the creditor with the given ID and data
   * @param id Creditor id
   * @param requestBody
   * @returns BillectaCreditor
   * @throws ApiError
   */
  public updateCreditor(
    id: string,
    requestBody: BillectaCreditorData,
  ): CancelablePromise<BillectaCreditor> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/creditors/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SelfInvoicing get all commissions on products for the given site
   * configures commission on the given product
   * @param id Site id
   * @returns ProductCommission
   * @throws ApiError
   */
  public siGetProductCommissions(
    id: string,
  ): CancelablePromise<Array<ProductCommission>> {
    return this.httpRequest.request({
      method: "GET",
      url: "/self-invoicing/{id}/commissions",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * SelfInvoicing set commission on product
   * configures commission on the given product
   * @param id Site id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public siPutProductCommission(
    id: string,
    requestBody: Array<CommissionData>,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/self-invoicing/{id}/commissions",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * DPLite user search
   * Search of DPLite users
   * @param requestBody
   * @returns DpLiteUserWithAccess
   * @throws ApiError
   */
  public dpliteUserSearch(
    requestBody: DpLiteSearch,
  ): CancelablePromise<Array<DpLiteUserWithAccess>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/dplite/users/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * DPLite user create
   * Create a DPLite user
   * @param requestBody
   * @returns DpLiteUserWithAccess
   * @throws ApiError
   */
  public dpliteUserCreate(
    requestBody: DpLiteCreateUserWithAccess,
  ): CancelablePromise<DpLiteUserWithAccess> {
    return this.httpRequest.request({
      method: "POST",
      url: "/dplite/users",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * DPLite user set access
   * Set password of a user
   * @param id
   * @param requestBody
   * @returns DpLiteAccess
   * @throws ApiError
   */
  public dpliteUserSetAccess(
    id: string,
    requestBody: Array<DpLiteSetAccess>,
  ): CancelablePromise<Array<DpLiteAccess>> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/dplite/users/{id}/access",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * DPLite user set password
   * Set password of a user
   * @param id
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public dpliteUserSetPassword(
    id: string,
    requestBody: DpLiteSetPassword,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/dplite/users/{id}/password",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * DPLite user get
   * Get a DpLiteUser
   * @param id
   * @returns DpLiteUserWithAccess
   * @throws ApiError
   */
  public dpliteUserGet(
    id: string,
  ): CancelablePromise<DpLiteUserWithAccess> {
    return this.httpRequest.request({
      method: "GET",
      url: "/dplite/users/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * DPLite user delete
   * Delete a DpLiteUser
   * @param id
   * @returns DpLiteUserWithAccess
   * @throws ApiError
   */
  public dpliteUserDelete(
    id: string,
  ): CancelablePromise<DpLiteUserWithAccess> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/dplite/users/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Create a new agreement with a permit attached to it
   * @param requestBody
   * @returns CreatePermitOutcome
   * @throws ApiError
   */
  public createPermit(
    requestBody: PermitCreate,
  ): CancelablePromise<CreatePermitOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Delete the permit agreement
   * @param agreementId
   * @returns any no content
   * @throws ApiError
   */
  public deletePermitAgreement(
    agreementId: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/agreement/{agreement_id}",
      path: {
        "agreement_id": agreementId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Preview payment for Permit
   * Permit Preview payment
   * @param agreementId
   * @returns PermitPayPreview
   * @throws ApiError
   */
  public previewPayPermit(
    agreementId: string,
  ): CancelablePromise<PermitPayPreview> {
    return this.httpRequest.request({
      method: "GET",
      url: "/permits/agreement/{agreement_id}/pay",
      path: {
        "agreement_id": agreementId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Pay for permit and activate it
   * Permit pay
   * @param agreementId
   * @returns PayPermitOutcome
   * @throws ApiError
   */
  public payPermit(
    agreementId: string,
  ): CancelablePromise<PayPermitOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/agreement/{agreement_id}/pay",
      path: {
        "agreement_id": agreementId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Preview payment for Permit period
   * Permit Preview payment for period
   * @param agreementId
   * @param period
   * @returns PermitPayPreview
   * @throws ApiError
   */
  public previewPayPermitPeriod(
    agreementId: string,
    period: Ym,
  ): CancelablePromise<PermitPayPreview> {
    return this.httpRequest.request({
      method: "GET",
      url: "/permits/agreement/{agreement_id}/pay-period/{period}",
      path: {
        "agreement_id": agreementId,
        "period": period,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Pay for permit period
   * Will not do anything to the agreement. Will not send email with receipt. Will only perform the payment and create an invoice.
   * @param agreementId
   * @param period
   * @returns PayPermitOutcome
   * @throws ApiError
   */
  public payPermitPeriod(
    agreementId: string,
    period: Ym,
  ): CancelablePromise<PayPermitOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/agreement/{agreement_id}/pay-period/{period}",
      path: {
        "agreement_id": agreementId,
        "period": period,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Create permit grant
   * @param permitId
   * @param requestBody
   * @returns PermitGrant
   * @throws ApiError
   */
  public permitCreateGrant(
    permitId: string,
    requestBody: CreatePermitGrant,
  ): CancelablePromise<PermitGrant> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/{permit_id}/grant",
      path: {
        "permit_id": permitId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns number
   * @throws ApiError
   */
  public permitBulkDeleteGrant(
    requestBody: GrantIds,
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/permits/{permit_id}/grant",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Retreives a grant
   * @param grantId
   * @returns PermitGrant
   * @throws ApiError
   */
  public permitGetGrant(
    grantId: string,
  ): CancelablePromise<PermitGrant> {
    return this.httpRequest.request({
      method: "GET",
      url: "/permits/grant/{grant_id}",
      path: {
        "grant_id": grantId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Search grants
   * @param requestBody
   * @returns Paginated_for_PermitGrantInfo
   * @throws ApiError
   */
  public searchGrants(
    requestBody: SearchGrants,
  ): CancelablePromise<Paginated_for_PermitGrantInfo> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/grant/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Retreives a grant
   * @param grantId
   * @param requestBody
   * @returns UpdateLicensePlateOutcome
   * @throws ApiError
   */
  public updateGrantLicensePlate(
    grantId: string,
    requestBody: UpdateLicensePlate,
  ): CancelablePromise<UpdateLicensePlateOutcome> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/permits/grant/{grant_id}/license_plate",
      path: {
        "grant_id": grantId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Start permit session
   * @param grantId
   * @param requestBody
   * @returns PermitSession
   * @throws ApiError
   */
  public permitSessionStart(
    grantId: string,
    requestBody: PermitSessionData,
  ): CancelablePromise<PermitSession> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/grant/{grant_id}/session",
      path: {
        "grant_id": grantId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Stop permit session
   * @param grantId
   * @returns any
   * @throws ApiError
   */
  public permitSessionStop(
    grantId: string,
  ): CancelablePromise<(PermitSession | null)> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/permits/grant/{grant_id}/session",
      path: {
        "grant_id": grantId,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * List all sessions for a permit
   * @param requestBody
   * @returns Paginated_for_PermitSession
   * @throws ApiError
   */
  public permitListSessions(
    requestBody: SearchPermitSessions,
  ): CancelablePromise<Paginated_for_PermitSession> {
    return this.httpRequest.request({
      method: "POST",
      url: "/permits/session/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Search for spot classes
   * @param requestBody
   * @returns SpotClass
   * @throws ApiError
   */
  public searchSpotClasses(
    requestBody: SearchSpotClasses,
  ): CancelablePromise<Array<SpotClass>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spot_classes/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * Get spots within a spotclass
   * @param requestBody
   * @returns Spot
   * @throws ApiError
   */
  public spotclassGetSpots(
    requestBody: SpotClassSpotSearch,
  ): CancelablePromise<Array<Spot>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/spot_classes/spots",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * AccessCodeSeries Search
   * Search for AccessCodeSeries
   * @param requestBody
   * @returns Paginated_for_AccessCodeSeries
   * @throws ApiError
   */
  public searchAccessCodeSeries(
    requestBody: SearchAccessCodeSeries,
  ): CancelablePromise<Paginated_for_AccessCodeSeries> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_code_series/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodeSeries Create
   * Create AccessCode series
   * @param requestBody
   * @returns AccessCodeSeries
   * @throws ApiError
   */
  public createAccessCodeSeries(
    requestBody: CreateAccessCodeSeries,
  ): CancelablePromise<AccessCodeSeries> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_code_series",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodeSeries Get
   * Get an AccessCodeSeries
   * @param id AccessCodeSeries id
   * @returns AccessCodeSeries
   * @throws ApiError
   */
  public getAccessCodeSeries(
    id: string,
  ): CancelablePromise<AccessCodeSeries> {
    return this.httpRequest.request({
      method: "GET",
      url: "/access_code_series/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodeSeries update
   * Updates an AccessCodeSeries
   * @param id AccessCodeSeries id
   * @param requestBody
   * @returns AccessCodeSeries
   * @throws ApiError
   */
  public updateAccessCodeSeries(
    id: string,
    requestBody: AccessCodeSeriesData,
  ): CancelablePromise<AccessCodeSeries> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/access_code_series/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodeSeries connected series
   * AccessCodeSeries connect series
   * @param id AccessCodeSeries id
   * @param requestBody
   * @returns ConnectAccessCodeSeriesOutcome
   * @throws ApiError
   */
  public postAccessCodeSeriesConnectedSeries(
    id: string,
    requestBody: AccessCodeSeriesIds,
  ): CancelablePromise<ConnectAccessCodeSeriesOutcome> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_code_series/{id}",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodeSeries Delete
   * Deletes an AccessCodeSeries
   * @param id AccessCodeSeries id
   * @returns any no content
   * @throws ApiError
   */
  public deleteAccessCodeSeries(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/access_code_series/{id}",
      path: {
        "id": id,
      },
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodeSeries set Sites
   * Sets the sites connected to an AccessCodeSeries
   * @param id AccessCodeSeries id
   * @param requestBody
   * @returns AccessCodeSeries
   * @throws ApiError
   */
  public accessCodeSeriesSetSites(
    id: string,
    requestBody: SiteIds,
  ): CancelablePromise<AccessCodeSeries> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_code_series/{id}/sites",
      path: {
        "id": id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCode Search
   * Search for AccessCodes
   * @param requestBody
   * @returns Paginated_for_AccessCode
   * @throws ApiError
   */
  public searchAccessCodes(
    requestBody: AccessCodesSearch,
  ): CancelablePromise<Paginated_for_AccessCode> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_codes/search",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodes create
   * Create AccessCodes in bulk
   * @param requestBody
   * @returns AccessCode
   * @throws ApiError
   */
  public bulkCreateAccessCodes(
    requestBody: AccessCodesBulkCreate,
  ): CancelablePromise<Array<AccessCode>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_codes/create",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodes update
   * Update AccessCodes in bulk
   * @param requestBody
   * @returns AccessCode
   * @throws ApiError
   */
  public bulkUpdateAccessCodes(
    requestBody: AccessCodesBulkUpdate,
  ): CancelablePromise<Array<AccessCode>> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_codes/update",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * AccessCodes delete
   * Delete AccessCodes in bulk
   * @param requestBody
   * @returns any no content
   * @throws ApiError
   */
  public bulkDeleteAccessCodes(
    requestBody: AccessCodeIds,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/access_codes/delete",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Login required`,
        403: `User does not have access to the requested resource`,
      },
    });
  }
  /**
   * @returns CounterState
   * @throws ApiError
   */
  public getCounter(): CancelablePromise<CounterState> {
    return this.httpRequest.request({
      method: "GET",
      url: "/counter",
    });
  }
}
